var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 25,
    viewBox: "0 0 30 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.3722 13.9708C30.2093 13.1573 30.2093 11.8362 29.3722 11.0227L18.6573 0.610113C17.8202 -0.203371 16.4607 -0.203371 15.6236 0.610113C14.7865 1.4236 14.7865 2.7447 15.6236 3.55818L22.6888 10.4175H2.14298C0.957643 10.4175 0 11.3481 0 12.5C0 13.6519 0.957643 14.5825 2.14298 14.5825H22.6821L15.6303 21.4418C14.7932 22.2553 14.7932 23.5764 15.6303 24.3899C16.4674 25.2034 17.8269 25.2034 18.664 24.3899L29.3789 13.9773L29.3722 13.9708Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlat);
export default __webpack_public_path__ + "static/media/flat.799e01a30adcfb4de9f65ab2b64fd055.svg";
export { ForwardRef as ReactComponent };